import React          from 'react'
import classnames     from 'classnames'
import { OwnProps }   from './types'
// @ts-ignore
import style          from './style.scss'

const ErrorPage = (props: OwnProps) => {
  const { children } = props

  return (
    <div className={classnames('container', style.errorPage)}>
      <h1>
        Something went wrong
      </h1>
      {children}
    </div>
  )
}

export default ErrorPage
